/**
 * Property Sticky Bar Module
 *
 * Shows a sticky price bar when scrolling past the gallery.
 *
 * @package TheRealEstates
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class PropertyStickyBar {
  constructor() {
    this.stickyBar = document.querySelector('[data-sticky-bar]');
    this.gallery = document.querySelector('[data-property-gallery]');

    if (!this.stickyBar || !this.gallery) return;

    this.init();
  }

  init() {
    // Show sticky bar when gallery is scrolled out of view
    ScrollTrigger.create({
      trigger: this.gallery,
      start: 'bottom top+=100',
      onEnter: () => this.show(),
      onLeaveBack: () => this.hide(),
    });

    // Also handle page load state
    this.checkInitialState();
  }

  checkInitialState() {
    const galleryRect = this.gallery.getBoundingClientRect();
    if (galleryRect.bottom < 100) {
      this.show();
    }
  }

  show() {
    this.stickyBar.classList.add('is-visible');
    gsap.to(this.stickyBar, {
      y: 0,
      opacity: 1,
      duration: 0.3,
      ease: 'power2.out',
    });
  }

  hide() {
    gsap.to(this.stickyBar, {
      y: '-100%',
      opacity: 0,
      duration: 0.3,
      ease: 'power2.in',
      onComplete: () => {
        this.stickyBar.classList.remove('is-visible');
      },
    });
  }

  destroy() {
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.trigger === this.gallery) {
        trigger.kill();
      }
    });
  }
}
